import { render, staticRenderFns } from "./BaseLoaderLite.vue?vue&type=template&id=faeb0846&scoped=true&functional=true&"
import script from "./BaseLoaderLite.vue?vue&type=script&lang=js&"
export * from "./BaseLoaderLite.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoaderLite.vue?vue&type=style&index=0&id=faeb0846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "faeb0846",
  null
  
)

export default component.exports